import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_AUTH_SERVICE,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// La sesión dura 8 horas: si vence en pleno turno se renueva sola y se repite la petición.
// (un 401 significa que el servidor no procesó nada, así que repetir es seguro)
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const refresh = localStorage.getItem('refresh_token');
    const isAuthCall = /\/api\/authentication\/(login|token\/refresh)\//.test(String(config?.url || ''));

    if (response?.status !== 401 || !config || config._retried || isAuthCall || !refresh) {
      return Promise.reject(error);
    }

    try {
      if (!refreshPromise) {
        refreshPromise = axios
          .post(
            `${process.env.REACT_APP_AUTH_SERVICE || ''}/api/authentication/token/refresh/`,
            { refresh },
            { timeout: 15000 }
          )
          .finally(() => {
            refreshPromise = null;
          });
      }
      const { data } = await refreshPromise;
      localStorage.setItem('token', data.access);
      if (data.refresh) localStorage.setItem('refresh_token', data.refresh);
    } catch (refreshError) {
      return Promise.reject(error);
    }

    config._retried = true;
    return api(config);
  }
);

export default api;
